import { notification } from 'ant-design-vue'

//const season = {'3':'C','4':'C','5':'C','6':'D','7':'D','8':'D','9':'A','10':'A','11':'A','12':'B','1':'B','2':'B'}

const season = {'3':'C','4':'C','5':'C','6':'A','7':'A','8':'A','9':'A','10':'A','11':'A','12':'B','1':'B','2':'B'}

export function getSchoolYear () {
    let month = new Date().getMonth() + 1
    let date = new Date()
    let dateTime = new Date().getFullYear();
    if( month >= 1 && month <=6){
        date = new Date(new Date().setFullYear(dateTime-1)).getFullYear()
    }else{
        date = new Date(new Date().setFullYear(dateTime)).getFullYear()
    }
    return date
}

export function getSemester(){
    return (season[new Date().getMonth()+1] =='C')?
    (getSchoolYear()+1+season[new Date().getMonth()+1]):getSchoolYear()+season[new Date().getMonth()+1]
}

export function selectedCheck(){
    notification['info']({
        message: '提示',
        description:'请选择一条记录再进行操作！',
    });
}

export function selectedMultiCheck(){
    notification['info']({
        message: '提示',
        description:'请选择至少一条记录再进行操作！',
    });
}

export function transformSeason(text){
    if(text.indexOf('A') > -1){
        return "秋季学期"
    }
    if(text.indexOf('B') > -1){
        return "冬季学期"
    }
    if(text.indexOf('C') > -1){
        return "春季学期"
    }
    if(text.indexOf('D') > -1){
        return "夏季学期"
    }
}

